import { withErrorHandling } from '@selfserve/react-hocs';
import { Box, CircularProgress } from '@mui/material';
import { UnisphereProvider, UnisphereRuntimeVisual } from '@unisphere/runtime-react';
import { useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Info24Icon, Clear24Icon } from '@kep-ui-kit/ui-icons';
import { buttonIds, routesPaths } from '@selfserve/react-utils';
import { StyledLink } from '@selfserve/react-ui';
import { useNavigate } from 'react-router-dom';
import { StyledButton } from '@selfserve/react-feature-account-management';

const Link = StyledLink.withComponent('a');

export const Plg = withErrorHandling(() => {
  const { t } = useTranslation();
  const [workspaceLoaded, setWorkspaceLoaded] = useState(false);
  const navigate = useNavigate();
  const [showSignInBanner, setShowSignInBanner] = useState(true);

  const env = useMemo(() => {
    const envMatch = window.location.hostname.match(/subscription\.(.+?)\.ovp\./);
    let env = '';
    const isLocalhost =
      window.location.hostname.startsWith('localhost') ||
      window.location.hostname.startsWith('http://localhost') ||
      window.location.hostname.startsWith('https://localhost');

    if (envMatch) {
      console.log('extracting env from hostname', envMatch[1]);
      env = envMatch[1];
    } else if (isLocalhost) {
      console.log(
        'no env match found in hostname and got isDev query param, assuming nvq2'
      );
      env = 'nvq2';
    } else {
      console.log('no env match found in hostname, assuming nvp1');
      env = 'nvp1';
    }
    return env;
  }, []);

  return (
    <Box className={'plg-root'} sx={{ height: '100vh' }}>
      {!workspaceLoaded && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100%',
          }}
        >
          <CircularProgress size={56} />
        </Box>
      )}
      <Helmet>
        <title>{t('titles.avatar-studio')}</title>
      </Helmet>
      <Box id="plg" sx={{
        height: workspaceLoaded ? '100vh' : 0,
        width: '100%',
      }}>
        <UnisphereProvider
          initialConfiguration={{
            appId: 'selfserve',
            appVersion: '1.0.0',
            serverUrl: `https://unisphere.${env}.ovp.kaltura.com/v1`,
            runtimes: [
              {
                widgetName: 'unisphere.widget.plg',
                runtimeName: 'setup-genie-avatar',
                settings: {},
              }
            ],
          }}
          onWorkspaceLoaded={() => setWorkspaceLoaded(true)}
        >
          <UnisphereRuntimeVisual
            runtimeName={"setup-genie-avatar"}
            widgetName={"unisphere.widget.plg"}
            visualType={"application"}
            visualSettings={{}}
          />
        </UnisphereProvider>
        {workspaceLoaded && showSignInBanner && <Box sx={{
          position: 'absolute',
          bottom: '16px',
          left: '16px',
          height: '48px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderRadius: '4px',
          backgroundColor: '#006EFA',
          boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.20), 0 4px 30px -8px rgba(0, 0, 0, 0.20)',
          color: 'white',
          padding: '4px 16px'
        }}>
          <Info24Icon />
          <span style={{ cursor: 'default' }}>{t('common.already-have-account')}</span>
          <Link
            to=""
            id={buttonIds.signIn}
            onClick={() => navigate(`${routesPaths.LOGIN_V2}?productFamily=AVATAR_STUDIO`)}
            style={{ color: 'white', textDecoration: 'underline', cursor: 'pointer' }}
            bold
          >
            {t('common.sign-in')}
          </Link>
          <StyledButton
            onClick={() => setShowSignInBanner(false)}
            style={{ display: 'flex', color: 'white' }}
            id={buttonIds.signInBannerPlg}
          >
            <Clear24Icon />
          </StyledButton>
        </Box>}
      </Box>
    </Box>
  );
});
